<script setup lang="ts">
import { useGlobalCounter } from '@/composables/useGlobalCounter';
import Checkbox from 'primevue/checkbox';
import Message from 'primevue/message';
import { useAttrs, type Ref } from 'vue';

defineOptions({
    // disable automatic attr inheritance: we do not want to pass attr to the root element,
    // but to the inner field instead
    inheritAttrs: false,
});

export type KpCheckboxProps = {
    label?: string;
    inputId?: string;
    inputValue?: any;
    inputClass?: string | object;
    error?: string | null;
};

const value: Ref<any> = defineModel();
const props = withDefaults(defineProps<KpCheckboxProps>(), {
    inputId: () => useGlobalCounter('field'),
    inputClass: '',
    inputValue: undefined,
    error: '',
});

const emit = defineEmits<{
    (e: 'change', value: any): void;
    (e: 'enter'): void;
}>();

const cls = useAttrs().class || null;
const fieldAttrs = { ...useAttrs() };
// Remove attributes for the inner field we do NOT want to pass along:
delete fieldAttrs.id;
delete fieldAttrs.class;
delete fieldAttrs.label;

function onChange(value: any) {
    emit('change', value);
}
</script>

<template>
    <div :class="`field ${cls}`">
        <div class="flex align-items-center gap-2">
            <Checkbox
                v-model="value"
                :inputId="inputId"
                :value="inputValue"
                v-bind="fieldAttrs"
                @value-change="onChange"
            />
            <label v-if="label" :for="inputId" v-html="label"></label>
        </div>
        <Message v-if="error" class="error" size="small" severity="error" variant="simple">{{ error }}</Message>
    </div>
</template>

<style lang="css" scoped>
.error {
    --p-message-text-font-weight: normal;
}
.field {
    label {
        font-size: 1rem;
        color: unset;
    }
}
</style>
